import axios from "axios";
import { isProdEnv } from "./isProdEnv";

/*
Callbacks can be omitted

If callbacks, structure is expected to be:
  {
    onSuccess: (function),
    onError: (function)
  }
*/
export default function postProspcalculator(data, callbacks) {
  const headers = {
    Authorization: "Basic c2tidnB1YmxpYzpvcGVuNEFsbFNsYWNrZXJz"
  };

  if (isProdEnv === false) {
    headers.TestMode = "TEST";
  }

  axios({
    method: "post",
    url: "https://hook.skbv.se/hook/rest/skbvpublichook/pubmsg/prospcalculator",
    headers,
    timeout: 2500,
    data
  })
    .then(function(response) {
      if (callbacks && callbacks.onSuccess) {
        callbacks.onSuccess(response);
      }
    })
    .catch(function(error) {
      console.log(error.toJSON());

      if (callbacks && callbacks.onError) {
        callbacks.onError(error);
      }
    });
}
